// extracted by mini-css-extract-plugin
module.exports = {"root":"index-module--root--363CI","text":"index-module--text--Crddu","logo":"index-module--logo--3PlfJ","colorCycle":"index-module--color-cycle--TimLx"};